var modReferFriend = function(){
    var scope = ".js-mod-refer-friend";
    ui.ready(scope,function($mod){

        var $confirmButton = $mod.find(scope+"__copy-link");

        $confirmButton.click(
            function(ev){
                ev.preventDefault();
                var $link = $mod.find(scope+"__link");
                $link.select();
                document.execCommand("copy");
                $link.blur();


                var $message = $("<div>").addClass("web-mod-refer-friend__message")
                .text("Link copied to clipboard!")

                $("body").append($message);

                setTimeout(function() {
                    $message.fadeOut(500, function() {
                        $(this).remove();
                    });
                }, 3000);
            }
       );

    });
}();